const synchronizeMaterial = async (currentMaterial, newMaterial, isRemoveTemp) => {
    const temp = {}
    currentMaterial.forEach(o => temp[o.materiel_id] = o)
    newMaterial.forEach(o => temp[o.materiel_id] = o)

    const updatedMaterial = []
    for (let key of Object.keys(temp)) {
        if(isRemoveTemp && key.includes("PWA")){
            continue
        }
        else {
            updatedMaterial.push(temp[key])
        }
    }

    return updatedMaterial
}

const synchronizeOperation = async (currentOperation, newOperation, isRemoveTemp) => {
    const temp = {}
    currentOperation.forEach(o => temp[o.exploitant_id] = o)
    newOperation.forEach(o => temp[o.exploitant_id] = o)

    const updatedOperation = []
    for (let key of Object.keys(temp)) {
        if(isRemoveTemp && key.includes("PWA")){
            continue
        }
        else {
            updatedOperation.push(temp[key])
        }
    }

    return updatedOperation
}

export {
    synchronizeMaterial,
    synchronizeOperation
}